import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ff1109a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "autologin-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Accesso in corso...")

import { IonContent, IonPage, IonText, toastController } from '@ionic/vue';
import axios from 'axios';
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();

async function openToastOptions(data: string, color = 'success') {
  const toast = await toastController.create({
    color: color,
    duration: 2000,
    message: data,
  });
  await toast.present();
}

function readAccessToken() {
  return (
    (route.query.accessToken as string | undefined) ||
    (route.query.token as string | undefined) ||
    (route.query.access_token as string | undefined)
  );
}

onMounted(async () => {
  const accessToken = readAccessToken();
  if (!accessToken) {
    await openToastOptions('Access token mancante', 'danger');
    router.replace({ name: 'login' });
    return;
  }

  try {
    const response = await axios.post(
      `${process.env.VUE_APP_APIURL}user-refresh`,
      { token: accessToken },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    const userData = response.data.data.user;
    const token = response.data.data.token;

    store.commit('user/setUser', userData);
    localStorage.setItem('userData', JSON.stringify(userData));
    localStorage.setItem('accessToken', token);
    localStorage.setItem('lastTokenRefresh', String(Date.now()));
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

    await openToastOptions('Login effettuato con successo', 'success');
    router.replace({ name: 'selectclass' });
  } catch (error: any) {
    const message =
      (error && error.response && error.response.data && error.response.data.message) ||
      'Autologin fallito';
    await openToastOptions(message, 'danger');
    router.replace({ name: 'login' });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonText), null, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})